import { Query, V2ATransfer } from '@varo/graphql-schema-types';
import { useCallback } from 'react';
import V2ATransferHistory from 'services/graphql/queries/MoveMoney/V2ATransferHistory';
import usePaginatedBaseQuery from 'shared/hooks/usePaginatedBaseQuery';

const useV2ATransferHistory = () => {
  const extractTransfers = useCallback(
    (data: Query) => ({
      edges: data?.v2aTransfers?.edges ?? [],
      pageInfo: {
        hasNextPage: !!data?.v2aTransfers?.pageInfo?.hasNextPage,
        endCursor: data?.v2aTransfers?.pageInfo?.endCursor ?? null,
      },
    }),
    [],
  );

  const removeDuplicate = (transfers: V2ATransfer[]) => {
    const uniqueIds = new Set();
    return transfers?.filter((transfer) => {
      const transferId = transfer.id;
      if (uniqueIds.has(transferId)) {
        return false;
      }
      uniqueIds.add(transferId);
      return true;
    });
  };

  const result = usePaginatedBaseQuery<V2ATransfer>({
    query: V2ATransferHistory,
    extractDataCallback: extractTransfers,
  });

  return { ...result, data: removeDuplicate(result.data ?? []) };
};

export default useV2ATransferHistory;
